/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompleteTestSuggestionResponse,
  DtoEnvelopeTestSuggestion,
  GetTestSuggestionsV1TestSuggestionsGetParams,
  HTTPValidationError
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Returns a list of test suggestions for the authenticated user.

Optionally filter by one or more statuses (pending, scheduled, completed, cancelled).
Pass multiple status query parameters to filter by multiple statuses.
Example: ?status=pending&status=scheduled
 * @summary Get Test Suggestions
 */
export const getTestSuggestionsV1TestSuggestionsGet = (
    params?: GetTestSuggestionsV1TestSuggestionsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<DtoEnvelopeTestSuggestion>(
      {url: `/v1/test-suggestions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetTestSuggestionsV1TestSuggestionsGetQueryKey = (params?: GetTestSuggestionsV1TestSuggestionsGetParams,) => {
    return [
    `/v1/test-suggestions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTestSuggestionsV1TestSuggestionsGetQueryOptions = <TData = Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError = HTTPValidationError>(params?: GetTestSuggestionsV1TestSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestSuggestionsV1TestSuggestionsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>> = ({ signal }) => getTestSuggestionsV1TestSuggestionsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTestSuggestionsV1TestSuggestionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>>
export type GetTestSuggestionsV1TestSuggestionsGetQueryError = HTTPValidationError


export function useGetTestSuggestionsV1TestSuggestionsGet<TData = Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError = HTTPValidationError>(
 params: undefined |  GetTestSuggestionsV1TestSuggestionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>,
          TError,
          Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTestSuggestionsV1TestSuggestionsGet<TData = Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError = HTTPValidationError>(
 params?: GetTestSuggestionsV1TestSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>,
          TError,
          Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTestSuggestionsV1TestSuggestionsGet<TData = Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError = HTTPValidationError>(
 params?: GetTestSuggestionsV1TestSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Test Suggestions
 */

export function useGetTestSuggestionsV1TestSuggestionsGet<TData = Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError = HTTPValidationError>(
 params?: GetTestSuggestionsV1TestSuggestionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestSuggestionsV1TestSuggestionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTestSuggestionsV1TestSuggestionsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Complete Test Suggestion
 */
export const completeTestSuggestionV1TestSuggestionsRecommendationIdPatch = (
    recommendationId: string,
 ) => {
      
      
      return customCatchBackendFetcher<CompleteTestSuggestionResponse>(
      {url: `/v1/test-suggestions/${recommendationId}`, method: 'PATCH'
    },
      );
    }
  


export const getCompleteTestSuggestionV1TestSuggestionsRecommendationIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>, TError,{recommendationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>, TError,{recommendationId: string}, TContext> => {

const mutationKey = ['completeTestSuggestionV1TestSuggestionsRecommendationIdPatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>, {recommendationId: string}> = (props) => {
          const {recommendationId} = props ?? {};

          return  completeTestSuggestionV1TestSuggestionsRecommendationIdPatch(recommendationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteTestSuggestionV1TestSuggestionsRecommendationIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>>
    
    export type CompleteTestSuggestionV1TestSuggestionsRecommendationIdPatchMutationError = HTTPValidationError

    /**
 * @summary Complete Test Suggestion
 */
export const useCompleteTestSuggestionV1TestSuggestionsRecommendationIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>, TError,{recommendationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeTestSuggestionV1TestSuggestionsRecommendationIdPatch>>,
        TError,
        {recommendationId: string},
        TContext
      > => {

      const mutationOptions = getCompleteTestSuggestionV1TestSuggestionsRecommendationIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    